import { ContentContainer } from "components/ui/display/ContentContainer";
import styled from "styled-components";

export const ToolsContainer = ({title = null, children}) => {
    return (
        <StyledToolsContainer padding='lg'>
            {
                title && title.length !== 0 ?
                <div className="title">
                    {title}
                </div>
                : null
            }
            
            <div className="content">
                {children}
            </div>
        </StyledToolsContainer>          
    )
}

const StyledToolsContainer = styled(ContentContainer)`
    div.title
    {
        cursor: default;
        padding-bottom: ${({theme}) => theme.spacing.md};
        margin-bottom: ${({theme}) => theme.spacing.lg};
        font-weight: 600;
        //font-size: ${({theme}) => theme.fontSize.lg};
        border-bottom: 1px solid ${({theme}) => theme.colors.neutralPrimaryBorder};
    }

    div.content
    {
        display: flex;
        flex-direction: column;
        gap: ${({theme}) => theme.spacing.lg};
    }
`